export default __webpack_public_path__ + "static/media/3.5a424a48.jpg";